
import { AnyAction } from "redux"
import { PRODUCTS_DASHBOARD_DATA_FAIL, PRODUCTS_DASHBOARD_DATA_REQ, PRODUCTS_DASHBOARD_DATA_SUCC } from "redux/actions/dashboard/type"
import { PRODUCTS_DATA_FAIL, PRODUCTS_DATA_REQ, PRODUCTS_DATA_SUCC } from "redux/actions/product/type"


interface State {
    loading?: boolean
    data?: any,
    error?: string,


}

const defaultState: State = {
    loading: false,
    data: [],


}


// export const PRODUCTS_DATA_FAIL="PRODUCTS_DATA_FAIL"
// export const PRODUCTS_DATA_REQ="PRODUCTS_DATA_REQ"
// export const PRODUCTS_DATA_SUCC="PRODUCTS_DATA_SUCC"

export const getProductsDashboardReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case PRODUCTS_DASHBOARD_DATA_REQ:

            return {
                loading: true,
                data: state.data
            }
        case PRODUCTS_DASHBOARD_DATA_SUCC:

            return {
                loading: false,
                data: action.payload,

            }
        case PRODUCTS_DASHBOARD_DATA_FAIL:
            return {
                loading: false,
                error: action.payload
            }


        default:
            return state;
    }
}